export default "__VITE_ASSET__4v_0etwv__"